import api from "@/api";
import { ApiCatalog } from "@/api/catalogs/ApiCatalog";
import { ContentOutline } from "@/bundles/types/ContentOutline";
import type { NextPageContext } from "next";

const ONE_MINUTE_MS = 60000;
const HEADLESS_TREE_QUERY_PARAMS = { viewmodel_type: "headless_tree" };

/**
 * Returns TanStack Query options for fetching a bundle's headless tree.
 * Accepts an optional `ctx` for server-side use (forwards auth cookies).
 * Intended to be passed directly to `useQuery` on the client and
 * `prefetchQuery` in `getServerSideProps`.
 */
export const headlessTreeQuery = (
  contentId: string,
  ctx?: NextPageContext,
) => ({
  queryKey: [
    ApiCatalog.singleContent.key,
    contentId,
    new URLSearchParams(HEADLESS_TREE_QUERY_PARAMS).toString(),
  ] as const,
  queryFn: () =>
    api({ ...(ctx && { ctx }), timeout: ONE_MINUTE_MS }).get(
      ApiCatalog.singleContent.endpoint,
      {
        queryParams: HEADLESS_TREE_QUERY_PARAMS,
        urlReplacers: [{ id: contentId }],
      },
    ) as Promise<ContentOutline>,
});
